import sizeChartAPI from '../../api/SizeChart'
import * as types from '../mutation-types'

// STATE
const state = {
    SizeChart: {},
    SizeChartOptions: []
}

// GETTERS
const getters = {
    SizeChartOptions: state => state.SizeChartOptions,
    SizeChart: state => state.SizeChart
}

// ACTIONS
const actions = {
    getSizeChartOptions({ commit }, params) {
        return new Promise((resolve, reject) => {
            sizeChartAPI.getSizeChartOptions(sizeChartOptions => {
                commit(types.RECEIVE_SIZECHART_OPTIONS, { sizeChartOptions })
                resolve()
            }, params)
        })
    },
    getSizeChart({ commit }, id) {
        return new Promise((resolve, reject) => {
            sizeChartAPI.getSizeChart(sizeChart => {
                commit(types.RECEIVE_SIZECHART, { sizeChart })
                resolve()
            }, id)
        })
    },
    createSizeChart({ commit }, params) {
        return new Promise((resolve, reject) => {
            sizeChartAPI.createSizeChart(sizeChart => {
                resolve(sizeChart)
            }, params)
        })
    },
    updateSizeChart({ commit }, params) {
        return new Promise((resolve, reject) => {
            sizeChartAPI.updateSizeChart(sizeChart => {
                resolve(sizeChart)
            }, params)
        })
    }
}

// MUTATIONS
const mutations = {
    [types.RECEIVE_SIZECHART_OPTIONS] (state, { sizeChartOptions }) {
        state.SizeChartOptions = sizeChartOptions
    },
    [types.RECEIVE_SIZECHART] (state, { sizeChart }) {        
        state.SizeChart = sizeChart
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
  


// WEBPACK FOOTER //
// ./src/store/modules/SizeChart.js